import { colors, ORDER_ISSUE_TYPES, ORDER_ITEM_ISSUES } from '@nandosaus/constants';
import { findLast, isNull, map } from 'lodash';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import { useState } from 'react';

import { Box, Flex } from '../../grid';
import { Button } from '../../button';
import { InputListItem } from '../../input-list-item';
import { P } from '../../typography';

const SelectOrderItemIssue = observer(() => {
  const { OrderHelpStore, MemberStore } = useRootStore();
  const [issue, setIssue] = useState(null);

  const ITEM_ISSUE =
    OrderHelpStore.orderIssue === ORDER_ISSUE_TYPES.WRONG_OR_MISSING_ITEM
      ? { list: ORDER_ITEM_ISSUES.DELIVERY, subheader: 'Oh no! We’re so sorry about that. What was wrong?' }
      : { list: ORDER_ITEM_ISSUES.QUALITY, subheader: 'What was wrong? ' };

  const getItemIssueText = itemIssue => {
    switch (itemIssue) {
      case ORDER_ITEM_ISSUES.QUALITY.TEMPERATURE:
        return 'Temperature - too cold or hot?';
      case ORDER_ITEM_ISSUES.QUALITY.PRESENTATION:
        return 'Presentation - did it not look right?';
      case ORDER_ITEM_ISSUES.QUALITY.PORTION_SIZE:
        return 'Portion Size - not the right proportions?';
      default:
        return itemIssue;
    }
  };

  const isGuestFlow = !MemberStore.isSignedIn;
  return (
    <>
      <P variant={3} mb={1}>
        {ITEM_ISSUE.subheader}
      </P>
      <Box>
        <Flex
          flexDirection="column"
          backgroundColor="white"
          borderTop={isGuestFlow ? `1px solid ${colors.grey100}` : ''}
        >
          {map(ITEM_ISSUE.list, (itemIssue, index) => {
            const showBorder = isGuestFlow ? true : itemIssue !== findLast(ITEM_ISSUE.list);
            return (
              <Flex
                py={1}
                mx={isGuestFlow ? 0 : 1}
                borderBottom={showBorder ? `solid 1px ${colors.grey100}` : 0}
                key={index}
              >
                <InputListItem
                  name={itemIssue}
                  type="radio"
                  label=""
                  selected={issue === itemIssue}
                  onSelect={() => setIssue(itemIssue)}
                  py="0"
                >
                  <P variant={2}>{getItemIssueText(itemIssue)}</P>
                </InputListItem>
              </Flex>
            );
          })}
        </Flex>
        <Button
          mt={1}
          onClick={() => {
            OrderHelpStore.setOrderItemIssue(issue);
            OrderHelpStore.goForward();
          }}
          name="next"
          disabled={isNull(issue)}
        >
          next
        </Button>
      </Box>
    </>
  );
});

export { SelectOrderItemIssue };
